module.exports = __webpack_public_path__ + "media/recipes/95-4265f4de.png";